<template>
  <v-app >
  <!-- <center> -->
<div id="load">
     <v-progress-circular v-if="preload" :size="50" color="primary" indeterminate ></v-progress-circular>
</div>
  <!-- </center> -->
<div  v-if="!preload" id="app">
  <center>
    <div v-if="!testlogin" id="login">
      <br>
      <img src="./assets/logo-guide.png" alt="guide" srcset="" class="logoLogin">
      <h1>Login</h1>
      <v-icon v-if="!login">mdi-account</v-icon>
      <v-icon color="red" v-if="login">mdi-account-alert</v-icon>
      <br>
        <v-form ref="form" @submit.prevent="Login">
        <v-text-field v-model="user.email" label="Email" class="col-sm-4" required ></v-text-field>

        <v-text-field type='password' v-model="user.password" label="Password" class="col-sm-4" required></v-text-field>
        <br>
        <v-alert id="alert" color="red" dense type="error" :value="alertEmail" >Email is required</v-alert>
        <v-alert id="alert" color="red" dense type="error" :value="alertPassword" >Password is required</v-alert>
        <v-alert id="alert" color="red" dense type="error" :value="alertUser" >Email or password is wrong</v-alert>
        <v-btn color="#1976d2" @click="Login">Login</v-btn>
      </v-form>
      <br>
    </div>
  </center>
  <div v-if="testlogin">
    <v-app-bar absolute  id="appbar" shrink-on-scroll scroll-target="#scrolling-techniques-2">
      <template v-slot:img="{ props }">
        <v-img v-bind="props"></v-img>
      </template>
        <v-row>
          <!-- <v-col class="columMenu"><v-btn class="btnMenu" color="blue" to="/">Tableau De Bord</v-btn></v-col> -->
          <v-col class="columMenu"><v-btn class="btnMenu" color="purple" to="/">Dashboard</v-btn></v-col>
          <v-col class="columMenu"><v-btn class="btnMenu" color="blue" to="/ventes">Ventes</v-btn></v-col>
          <v-col class="columMenu"><v-btn class="btnMenu" color="orange" to="/primes">Primes</v-btn></v-col>
          <v-col class="columMenu"><v-btn class="btnMenu" color="green" to="/guides">Guides</v-btn></v-col>
          <v-col class="columMenu"><v-btn class="btnMenu" color="indigo" to="/agence">Agences</v-btn></v-col>
        </v-row>
    </v-app-bar>
    <br>
    <v-sheet id="scrolling-techniques-2" class="overflow-y-auto" max-height="600" style="max-height: 600px;z-index: 99;margin-top: 120px;">
      <v-navigation-drawer v-model="drawer" absolute bottom temporary color="#00000080;" style="background-color:#00000080 ;">
        <v-list nav dense>
          <v-list-item-group active-class="deep-purple--text text--accent-4" color="#2A505F;">
            <v-list-item>
              <v-list-item-title style="color: white; text-align: center;" ><img src="./assets/logo.png" alt="Med Shop" width="150" height="109"></v-list-item-title>     
            </v-list-item>
            <br><br>
            <!-- <v-list-item to="/">
            <v-icon color="white">mdi-chart-areaspline</v-icon>
              <v-list-item-title style="color: white;" class="spacing-playground pa-4" >Dashboard</v-list-item-title>     
            </v-list-item> -->
            <v-list-item to="/ventes">
              <v-icon color="white">mdi-cart</v-icon>
              <v-list-item-title style="color: white;" class="spacing-playground pa-4">Ventes</v-list-item-title>     
            </v-list-item>
            <v-list-item to="/primes">
              <v-icon color="white">mdi-calendar</v-icon>
              <v-list-item-title style="color: white;" class="spacing-playground pa-4" >Primes</v-list-item-title>     
            </v-list-item>
            <v-list-item to="/guides">
            <v-icon color="white">mdi-storefront-outline</v-icon>
              <v-list-item-title style="color: white;" class="spacing-playground pa-4" >Guides</v-list-item-title>     
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>
    </v-sheet>
    <v-main>
      <v-container fluid>
      <router-view/>
      
      </v-container>
    </v-main>
  </div>
  <v-footer app id="footer">
    <img src="./assets/logo-guide.png" alt="guide" srcset="" class="logoLogin">
  </v-footer>
</div>
</v-app>
</template>


<style>
*{
 font-size: 25px;
}
#load{
  position: relative;top: 50%;bottom: 50%;right: 50%;left: 50%;
}
#login{
  margin:12% 12% 12% 12%; 
  /* box-shadow:5px 5px 5px 10px #fff6; */
  background-color: #fff6 !important;
}
#footer{
  background-color: #ffffff26 !important;
  text-align:center !important;
}
#appbar{
  background-color:#ffffff38;
}
#app{
/* background-color: blue !important; */
height:100%;
/* background-image:url('https://picsum.photos/1920/1080?random') !important; */
background-image:url('./assets/backgrund_art.jpeg') !important;
background-repeat: no-repeat;
background-size: 100% 100%;
}
#alert{
  width:300px;
}
.v-data-footer__select{
  display: none !important;
}
.columMenu{
  /* padding: ; */
  width: 170px !important;
}
.btnMenu{
  color: white !important;
  margin: 10px;
  width: 100% !important;
  height: 80px !important;
}
.logoLogin{
  /* width: 50px !important; */
  height: 80px !important;
}
</style>


<script>
import Vue from 'vue'
import axios from 'axios'
import Vuetify from 'vuetify/lib'
Vue.use(Vuetify)
export default {
  name: 'App',
   data(){
    return {
      localhost:'https://guide.artnaji.com/index.php/api',
      // localhost:'http://localhost:8000/api',
      alertUser:false,
      alertPassword:false,
      alertEmail:false,
      imgback:'',
      login:false,
      preload:true,
      testlogin:false,
      circular:false,
      user:{},
      drawer: null,
    }
  },
  created () {
      this.preload=false
      if(!localStorage.getItem('user-token')){
        // window.location.href = '../';
        this.testlogin=false
      }
      else{
        if(localStorage.getItem('user-token') == null){
          this.testlogin=false
        }else{          
          this.testlogin=true
        }        
      }
    }
    ,methods: {
      Login(){
        if (!this.user.email) {
          this.alertEmail=true
        }
        if (!this.user.password) {
          this.alertPassword=true
        }
        if (!this.user.passsword && !this.user.email) {
          // alert('3')
        }else{
         this.alertEmail=false
         this.alertPassword=false

        axios.post(this.localhost+'/login',this.user).then(Response=>{
          this.login=false;
          // console.log(Response.data.success) sir nchuf
          let token=Response.data.token
          // alert(Response.data.token)
          localStorage.setItem('user-token', token)
          this.testlogin=true
          console.log(localStorage.getItem('user-token'))
        }) 
        .catch(error=> {
          console.log(error);
          this.login=true;
          this.alertUser=true
          this.user.password=''
        })
        }
      }
    }
};

</script>